import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ClassificacaoFaturamento } from '../classificacao-faturamento';

@Injectable({
    providedIn: 'root'
})
export class ClassificacaoFaturamentoCrudHttpService implements Crud<ClassificacaoFaturamento> {
    resource = 'classificacaofaturamento';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas as classificações de faturamento cadastradas */
    search(): Observable<ClassificacaoFaturamento[]> {
        return this.crudService.search<ClassificacaoFaturamento>(this.resource);
    }

    /** Procura uma única classificação de faturamento através do seu ID */
    find(id: number): Observable<ClassificacaoFaturamento> {
        return this.crudService.find<ClassificacaoFaturamento>(this.resource, id);
    }

    /** Carrega uma única classificação de faturamento através do seu ID */
    load(id: number): Observable<ClassificacaoFaturamento> {
        return this.crudService.load<ClassificacaoFaturamento>(this.resource, id);
    }

    /** Insere uma nova classificação de faturamento */
    insert(entity: ClassificacaoFaturamento): Observable<ClassificacaoFaturamento> {
        return this.crudService.insert<ClassificacaoFaturamento>(this.resource, entity);
    }

    /** Altera uma classificação de faturamento existente */
    update(entity: ClassificacaoFaturamento): Observable<ClassificacaoFaturamento> {
        return this.crudService.update<ClassificacaoFaturamento>(this.resource, entity);
    }

    /** Exclui uma classificação de faturamento através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
